/* templates */
import {default as warningTemp} from './src/templates/warning.html';
import {default as tourTemp} from './src/templates/tour.html';
import {default as updatesTemp} from './src/templates/updatesList.html';
import {default as modelsTemp} from './src/templates/modelsList.html';
import {default as modelTemp} from './src/templates/model.html';
import {default as joinTemp} from './src/templates/join.html';
import {default as trailerTemp} from './src/templates/trailer.html';
import {default as videoTemp} from './src/templates/videoContent.html';
import {default as imageTemp} from './src/templates/imageContent.html';
import {default as tocTemp} from './src/templates/toc.html';
import {default as twoTwoFiveSevenTemp} from './src/templates/2257.html';
import {default as affilatesTemp} from './src/templates/affiliates.html';
import {default as linksTemp} from './src/templates/links.html';
import {default as contactTemp} from './src/templates/contact.html';
import {default as paginationTemp} from './src/templates/pagination.html';

export const theme = {
  templates : {
    warningTemp,
    tourTemp,
    updatesTemp,
    modelsTemp,
    modelTemp,
    joinTemp,
    trailerTemp,
    videoTemp,
    imageTemp,
    tocTemp,
    twoTwoFiveSevenTemp,
    affilatesTemp,
    linksTemp,
    contactTemp,
    paginationTemp
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/core_theme_1/index.js
// module id = 147
// module chunks = 0